module.exports = __webpack_public_path__ + "img/finishChecked4.5ecd12f7.png";